namespace $.$$ {
	$mol_style_define( $mol_toolbar_demo , {
		alignSelf: 'stretch'
	} )
}
